var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"indigo","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© 2020 By Csaba vitéz Fehér")])])
}
var staticRenderFns = []

export { render, staticRenderFns }